import React, { useState, useEffect } from 'react';
import { homePageStyles } from './HomePage.styles';

const ChromeExtensionPromo = () => {
  const [visible, setVisible] = useState(false);
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    // Function to check if device is desktop
    const checkDesktop = () => setIsDesktop(window.innerWidth >= 768);
    checkDesktop();
    window.addEventListener('resize', checkDesktop);
    return () => window.removeEventListener('resize', checkDesktop);
  }, []);

  useEffect(() => {
    if (!isDesktop) {
      setVisible(false);
      return;
    }
    // Check localStorage for dismissal timestamp
    const dismissedAt = localStorage.getItem('chromePromoDismissedAt');
    if (dismissedAt) {
      const now = Date.now();
      const diff = now - parseInt(dismissedAt, 10);
      // 24 hours = 86400000 ms
      if (diff < 86400000) {
        setVisible(false);
        return;
      }
    }
    setVisible(true);
  }, [isDesktop]);

  const handleClose = () => {
    setVisible(false);
    localStorage.setItem('chromePromoDismissedAt', Date.now().toString());
  };

  if (import.meta.env.VITE_FEATURE_CHROME_PROMO !== 'true') return null;
  if (!visible) return null;
  
  return (
    <div style={homePageStyles.chromePromoContainer}>
      <button
        onClick={handleClose}
        style={homePageStyles.chromePromoCloseButton}
        aria-label="Close"
      >
        ×
      </button>
      <div style={homePageStyles.chromePromoText}>
        Optional Chrome extension for filtered Google Search results.
        <br />
        Third-party add-on; not required to use Explore.
      </div>
      <a
        href="https://chromewebstore.google.com/detail/kids-safe-search-engine/fjmiccpdnbjkegppnjkamgbbjpbmgabn?hl=en"
        target="_blank"
        rel="noopener noreferrer"
        style={homePageStyles.chromePromoLink}
      >
        View extension in Chrome Web Store
      </a>
    </div>
  );
};

export default ChromeExtensionPromo; 